<template>
    <div class='jt-icon'>
        <div class='icon-container'>
            <div class='left-border-container'>
                <div class='square-6'></div>
                <div class='square-7'></div>
                <div class='square-8'></div>
                <div class='square-9'></div>
                <div class='square-10'></div>
            </div>
            <div class='center-square'></div>
            <div class='right-border-container'>
                <div class='square-1'></div>
                <div class='square-2'></div>
                <div class='square-3'></div>
                <div class='square-4'></div>
                <div class='square-5'></div>
            </div>
        </div>
        <img 
                class="logoImg"
                :src="$fetchIp+'/static/images/shops/'+shopData.coverImg" 
                alt=""
            >
    </div>
</template>
  
<script>
export default {
    name: 'loadingScreen',
    components: {
    },
    props: {
        shopData: null,
    },
    // watch: {
    //     shippingProfile: {
    //         handler(newVal) {
    //             if (newVal) {
    //                 this.render = true
    //                 this.setShippingMethods()
    //                 // this.setShopData()
    //             }
    //         },
    //         immediate: true, // Executes the watcher immediately on component creation
    //         deep: true // Watches the nested properties if needed
    //     }
    // },
    data() {
        return {
            
        };
    },
    computed: {
      
    },
    methods: {
        
    },
    created() {
        

    },
    mounted() {
      // Lifecycle hook - called after the component is mounted to the DOM
    
    },
    updated() {
      // Lifecycle hook - called after a data change causes the DOM to re-render
    
    },
  };
</script>
  
<style scoped>
.jt-icon {
    top: -30px;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
	position: absolute;
	height: fit-content;
	width: fit-content;
}
.logoImg {
    margin-top: 75px;
    margin-left: -50px;
}
 .jt-icon .icon-container {
	position: absolute;
	top: 30px;
	left: 40px;
	height: 120px;
	width: 120px;
	transform: rotate(45deg);
}
 .jt-icon .icon-container .left-border-container div {
	position: absolute;
	height: 30px;
	width: 30px;
	background: linear-gradient(to bottom right, #0083CE, #65b6e6);
}
 .jt-icon .icon-container .left-border-container .square-6 {
	top: 90px;
	left: 60px;
	animation: square-animation 1s infinite;
	animation-delay: 0.5s;
}
 .jt-icon .icon-container .left-border-container .square-7 {
	top: 90px;
	left: 30px;
	animation: square-animation 1s infinite;
	animation-delay: 0.6s;
}
 .jt-icon .icon-container .left-border-container .square-8 {
	top: 90px;
	animation: square-animation 1s infinite;
	animation-delay: 0.7s;
}
 .jt-icon .icon-container .left-border-container .square-9 {
	top: 60px;
	animation: square-animation 1s infinite;
	animation-delay: 0.8s;
}
 .jt-icon .icon-container .left-border-container .square-10 {
	top: 30px;
	animation: square-animation 1s infinite;
	animation-delay: 0.9s;
}
 .jt-icon .icon-container .center-square {
	position: absolute;
	top: 33px;
	left: 33px;
	height: 54px;
	width: 54px;
	/* background-color: #00bfff; */
    background: linear-gradient(to right, #65b6e6, #65e6e6);
    border-radius: 5px;
}
 .jt-icon .icon-container .right-border-container div {
	position: absolute;
	height: 30px;
	width: 30px;
	background: linear-gradient(to bottom right, #00c7ce, #65e6e6);
}
 .jt-icon .icon-container .right-border-container .square-1 {
	left: 30px;
	animation: square-animation 1s infinite;
}
 .jt-icon .icon-container .right-border-container .square-2 {
	left: 60px;
	animation: square-animation 1s infinite;
	animation-delay: 0.1s;
}
 .jt-icon .icon-container .right-border-container .square-3 {
	left: 90px;
	animation: square-animation 1s infinite;
	animation-delay: 0.2s;
}
 .jt-icon .icon-container .right-border-container .square-4 {
	right: 0;
	top: 30px;
	animation: square-animation 1s infinite;
	animation-delay: 0.3s;
}
 .jt-icon .icon-container .right-border-container .square-5 {
	right: 0;
	top: 60px;
	animation: square-animation 1s infinite;
	animation-delay: 0.4s;
}
 @keyframes square-animation {
	0% {
		transform: scale(1);
	}
	20% {
		transform: scale(0.5);
	}
	40% {
		transform: scale(1);
	}
	60% {
		transform: scale(1);
	}
}
 
</style>